import React, { Component } from 'react'
import ResourceItem from '../../models/resourceItem'

import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.less';
import 'swiper/components/navigation/navigation.less';
SwiperCore.use([Navigation])


interface iProps {
    extraProps: ResourceItem[]
}
interface iState {
}
export default class clazzPictures extends Component<iProps, iState> {
    state: iState = {
    }
    onChange = () => {}
    render() {
        let {extraProps} = this.props
        return (
            <div className="clazzPictures">
                <Swiper
                    style={{width: '100%'}}
                    slidesPerView={1}
                    navigation
                    onSlideChange={() => console.log('slide change')}
                    onSwiper={(swiper) => console.log(swiper)}
                    >
                        {
                            extraProps && !!(extraProps.length) && extraProps.map(item => (
                                <SwiperSlide key={item.id}>
                                    <img src={item.playUrl} alt="" />
                                </SwiperSlide>

                            ))
                        }
                </Swiper>
            </div>
        )
    }
}
